/* RareTCG mobile search gesture guard.
 * A scroll gesture must never become navigation just because it began on a
 * result. In particular, RareTCG's older discovery handler navigated on
 * pointerdown and the header guard blurred the search input on pointerdown.
 * Intercept touch pointerdown at window-capture, then allow activation only
 * through the normal click generated after a completed tap. */
(() => {
  if (window.__rtcgMobileRuntimePolish) return;
  window.__rtcgMobileRuntimePolish = true;

  const mobile = window.matchMedia('(max-width: 989px)');
  const searchLayerFor = target => target?.closest?.('[data-rtcg-search-layer][open]');
  const findTouch = (list, id) => {
    for (let index = 0; index < list.length; index += 1) {
      if (list[index].identifier === id) return list[index];
    }
    return null;
  };
  let touch = null;
  let suppressClickUntil = 0;

  window.addEventListener('pointerdown', event => {
    if (!mobile.matches || event.pointerType !== 'touch') return;
    if (!searchLayerFor(event.target)) return;

    /* Stop document/target pointerdown handlers only. Do not cancel the
       default action: inputs still focus and links/buttons still receive their
       ordinary click after pointerup. Keyboard dismissal is handled by the
       existing touchmove path once a real drag begins. */
    event.stopPropagation();
  }, true);

  window.addEventListener('touchstart', event => {
    if (!mobile.matches || !searchLayerFor(event.target) || event.touches.length !== 1) {
      touch = null;
      return;
    }
    const point = event.touches[0];
    touch = { id: point.identifier, x: point.clientX, y: point.clientY, moved: false };
  }, { capture: true, passive: true });

  window.addEventListener('touchmove', event => {
    if (!touch) return;
    const point = findTouch(event.touches, touch.id);
    if (!point) return;
    const distance = Math.hypot(point.clientX - touch.x, point.clientY - touch.y);
    if (distance > 8) touch.moved = true;

    /* Ignore micro-movement so a normal tap doesn't dismiss the keyboard.
       Once movement is intentional, allow the document's passive touchmove
       handler through so the keyboard can dismiss and native scrolling wins. */
    if (!touch.moved) event.stopPropagation();
  }, { capture: true, passive: true });

  window.addEventListener('touchend', event => {
    if (!touch || !findTouch(event.changedTouches, touch.id)) return;
    if (touch.moved) suppressClickUntil = performance.now() + 160;
    touch = null;
  }, { capture: true, passive: true });

  window.addEventListener('touchcancel', () => {
    if (touch?.moved) suppressClickUntil = performance.now() + 160;
    touch = null;
  }, { capture: true, passive: true });

  window.addEventListener('click', event => {
    if (performance.now() > suppressClickUntil) return;
    if (!searchLayerFor(event.target) || !event.target.closest?.('a[href], button')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    suppressClickUntil = 0;
  }, true);
})();
